import { render, staticRenderFns } from "./kia-flat-rate-import-view.vue?vue&type=template&id=16db1786&scoped=true&"
import script from "./kia-flat-rate-import-view.vue?vue&type=script&lang=js&"
export * from "./kia-flat-rate-import-view.vue?vue&type=script&lang=js&"
import style0 from "./kia-flat-rate-import-view.vue?vue&type=style&index=0&id=16db1786&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db1786",
  null
  
)

export default component.exports